import type { TrendItemContentTweetsItemBasicInfoAllOfTwoTweetType } from './trendItemContentTweetsItemBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type TrendItemContentTweetsItemBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: TrendItemContentTweetsItemBasicInfoAllOfTwoTweetType;
};
